import { Environment } from './environment.service';

import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class EvergladesEnvironment extends Environment {
  constructor() {
    super();

    super.setup(environment);
  }
}
